import {
  MODULE_MANIFESTS,
  buildServiceModulesFromManifests,
} from "@/modules/manifestRegistry";

// Backward-compatible exports (older code imports these constants/functions).
// Internally, everything is sourced from per-module manifests.

export const SERVICE_MODULES = buildServiceModulesFromManifests();

export const SERVICE_MODULE_KEYS = SERVICE_MODULES.map((module) => module.key);

export const FREE_MODULE_KEYS = MODULE_MANIFESTS.filter(
  (m) => m.isFreeModule === true
).map((m) => m.key);

// "Non-purchasable" here means: not offered as a standalone paid module.
// We intentionally exclude free modules from this list, otherwise the module
// subscription UI would hide them completely.
export const NON_PURCHASABLE_MODULE_KEYS = MODULE_MANIFESTS.filter(
  (m) => m.isPurchasable === false && m.isFreeModule !== true
).map((m) => m.key);

export const getServiceModuleByKey = (moduleKey) =>
  SERVICE_MODULES.find((module) => module.key === moduleKey) || null;

export const getServiceModuleName = (
  moduleOrKey,
  language = "en",
  variant = "dashboard"
) => {
  const module =
    typeof moduleOrKey === "string"
      ? getServiceModuleByKey(moduleOrKey)
      : moduleOrKey;

  if (!module) return "";

  const useArabic = language === "ar";
  if (variant === "plan") {
    return useArabic ? module.planNameAr : module.planNameEn;
  }

  return useArabic ? module.dashboardNameAr : module.dashboardNameEn;
};

export const normalizeAllowedModules = (value) => {
  if (!Array.isArray(value)) return [];
  const allowed = new Set(SERVICE_MODULE_KEYS);
  return value.filter(
    (item, index) => allowed.has(item) && value.indexOf(item) === index
  );
};

export const matchModuleByPath = (pathname = "") =>
  SERVICE_MODULES.find((module) =>
    module.matchers.some((matcher) => matcher.test(pathname))
  ) || null;

